import { EventEmitter, Output } from "@angular/core";
import { BaseComponent, BaseModel } from "./base-component";

export class BButtonComponent extends BaseComponent {
  /// se le cambia el tipo de formato
  Skeleton: ButtonModel;
  constructor() {
    super();
  }

  /**
   * @author Jose Wilson Mulato
   * @description Eventos de cambio estado
   */
  @Output("s-click")
  EvtClick: EventEmitter<any> = new EventEmitter<any>();

  /**
   * @author Jose Wilson Mulato
   * @description escucha el clin del boton
   */
  OnClick() {
    this.EvtClick.emit();
  }
}

export class ButtonModel extends BaseModel {
  IconCss?: string;
  Disable?: boolean;
}



// WEBPACK FOOTER //
// ./src/app/shared/extends-components/bbutton-component.ts